
import 'bootstrap-modal/css/bootstrap-modal.css';
import 'bootstrap-modal/js/bootstrap-modal.js';
import 'bootstrap-modal/js/bootstrap-modalmanager.js';

import each from 'lodash/each';
import makeFormModalModernTemplate from './modals/make_form_modern_modal.tpl';
import serializeJqueryForm from 'zoomforth_zfutils/serialize_jquery_form.js';

const makeFormModal = function(settings){
  var deferred = $.Deferred();
  var inputs = settings.inputs;
  var title = settings.title || null;
  var submitText = settings.submitText || 'Submit';
  var highlight = settings.highlight;
  var enterToSubmit = (settings.enterToSubmit === undefined) ? true : !!settings.enterToSubmit;
                      
  var modalHtml = makeFormModalModernTemplate({
    inputs: inputs,
    title: title,
    submitText: submitText,
    each
  });
  var $myModal = $(modalHtml);

  window.setTimeout(function(){
    var submitForm = function(){
      var serialized = serializeJqueryForm($myModal.find('.modal-body *'));
      deferred.resolve(serialized);
      $myModal.modal('hide');
    };
    $myModal.find('.submitFormModal').bind('click', submitForm);
    if(enterToSubmit) { 
      $myModal.bind('keyup', function(e){
        if (e.which == 13) { //return
          submitForm(e);
        }
      });
    }
    
    $myModal.on('hidden', function(){
      deferred.reject();
    });
    $myModal.modal({focusOn:'input:first'});
    if (highlight) {
      $myModal.find('input:first').select();
    }
  },0);
  return deferred.promise();
};

const quickForm = function(options){
  // takes title, and label, and value
  var deferred = $.Deferred();
  
  makeFormModal({
    title: options.title,
    highlight: true,
    submitText: options.submitText || 'Submit',
    inputs:[{
      key: options.label,
      name: 'quick_form_value',
      value: options.value || '',
      placeholder: options.placeholder || ''
    }]
  }).done(function(form){
    deferred.resolve(form.quick_form_value);
  }).fail(function(){
    deferred.reject();
  });
  return deferred.promise();
};


export {
  makeFormModal,
  quickForm
};

export default {
  makeFormModal,
  quickForm
};